<template>
  <div class="container">
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='disablePage'
      :current='page' :count='count'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>同步时间:</label>
            <timeStampDatePicker :maxlength='100'  type='daterange' placeholder='请选择' class="item"
              clearable v-model.trim='query.timeArray' ></timeStampDatePicker>
          </div>
           <div class="queryItem">
            <label>DTP类型:</label>
            <div class="dtpTypeCon">
            <lk-select v-model="query.dtpType" :clearable='true' placeholder='请选择' class="item dtpType" :multiple='true' >
              <lk-option v-for="(item,i) in dtpTypeEnumMap" :key="i" :value='i'>{{ item }}</lk-option>
            </lk-select>
            <lk-icon v-if="query.dtpType.length" class='icon'  type="ios-close-circle" @click="query.dtpType=[]"/>
            </div>
          </div>
           <div class="queryItem">
            <label>DTP编码:</label>
            <lk-input class="item" v-model.trim="query.bizCode" placeholder='请输入' clearable></lk-input>
          </div>
          <div class="queryItem">
            <label>SAP编码:</label>
            <lk-input class="item" v-model.trim="query.sapCode" placeholder='请输入' clearable></lk-input>
          </div>
           <div class="queryItem">
            <label>是否冲销:</label>
            <lk-select v-model="query.doReverse" placeholder='请选择' class="item" clearable>
              <lk-option v-for="(item,i) in doReverseList" :key="i" :value='item.id'>{{ item.name }}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>门店:</label>
             <storeListSelect class="item" v-model="query.storeList" placeholder='请输入门店名称或公司代码'></storeListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-menu width='100%' mode="horizontal" active-name='1' @on-select='handleSelected'>
        <lk-menu-item v-for="item in menu" :key='item.index' :name='item.index'>
          {{item.name}}
        </lk-menu-item>
      </lk-menu>
        <div class="downBtn">
          <DownloadButton @on-click="download" v-if="handlePermission('linkedQueryDownLoadBtn')">
          </DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>

<script>
import DownloadButton from '@/components/download/DownloadButton';
import QueryFrame from '@/components/frame/QueryFrame.vue';
import queryMixins from '@/mixins/queryMixins';
import tools from '@/services/tools';
import utils from '@/libs/utils';

export default {
  name: 'linkedQuery',
  mixins: [queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
  },
  computed: { },
  data() {
    return {
      dtpTypeEnumMap: {}, // DTP类型map
      doReverseList: [
        {
          id: 1,
          name: '是',
        },
        {
          id: 0,
          name: '否',
        },
      ],
      menu: [
        {
          index: '1',
          name: '采购及库存单据',
        },
        {
          index: '2',
          name: '发票校验',
        },
        {
          index: '3',
          name: '销售单据',
        },
        {
          index: '4',
          name: '会计凭证',
        },
      ],
      columns: [
        {
          title: '序号',
          key: 'index',
          width: 80,
          type: 'index',
        },
        {
          title: '门店名称',
          key: 'name',
          minWidth: 136,
        },
        {
          title: 'SAP公司代码',
          key: 'compayCode',
          minWidth: 116,
        },
        {
          title: '同步时间',
          minWidth: 136,
          render: (h, { row }) => h('span', utils.exchangeTimeToSecond(row.createTime)),
        },
        {
          title: 'DTP类型',
          key: 'dtpTypeValue',
          minWidth: 116,
        },

        {
          title: 'DTP单号',
          key: 'bizCode',
          minWidth: 116,
        },
        {
          title: 'SAP类型',
          key: 'bizTypeValue',
          minWidth: 116,
        },
        {
          title: 'SAP编号',
          key: 'sapCode',
          minWidth: 116,
        },
        {
          title: '是否冲销',
          minWidth: 116,
          render: (h, { row }) => h('span', row.doReverse ? '是' : ''),
        },
        {
          title: '冲销时间',
          minWidth: 116,
          render: (h, { row }) => h('span', row.reverseTime ? utils.exchangeTimeToSecond(row.reverseTime) : ''),
        },
        {
          title: 'SAP冲销凭证号',
          minWidth: 116,
          render: (h, { row }) => h('span', row.reverseCode ? row.reverseCode : ''),
        },
      ],
      query: {
        startTime: null, // 同步时间-开始
        endTime: null, // 同步时间-结束
        dtpType: [], // DTP类型
        bizCode: null, // DTP编码
        sapCode: null, // SAP编码
        doReverse: null, // 是否冲销
        storeList: [], // 门店
        sapCategory: 1, // 查询维度
      },
      tableData: [],
    };
  },
  methods: {
    // handleSearch() {
    //   this.page = 1;
    //   this.size = 20;
    //   this.getData();
    // },
    handleSelected(val) {
      this.getRelationQuery(val);
      this.clear();
      this.query.sapCategory = val - 0;
      this.page = 1;
      this.size = 20;
      this.getData();
    },
    download() {
      const params = this.query;
      params.queryCondition = utils.getQueryCondition('.queryContainer');// 请求参数添加汉语检索条件
      tools.downloadSapBillRelation(params).then((res) => {
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      utils.objInit(this.query, 'sapCategory');
      this.query.timeArray = [];
    },
    formatParams(params) {
      const temp = utils.deepClone(params);
      temp.page = this.page;
      temp.size = this.size;
      return temp;
    },
    getData() {
      if (Object.keys(this.query).indexOf('timeArray') >= 0 && this.query.timeArray.length > 0) {
        [this.query.startTime, this.query.endTime] = this.query.timeArray;
      } else {
        this.query.startTime = null;
        this.query.endTime = null;
      }
      const params = this.formatParams(this.query); // 请求参数添加page，size
      tools.getSapBillRelationPage(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRelationQuery(params) {
      tools.getSapBillRelationQuery({ sapCategory: params }).then((res) => {
        if (res.data.status === 200) {
          const temp = res.data.data;
          this.dtpTypeEnumMap = temp.dtpTypeEnumMap;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {

  },
  created() {
    this.getRelationQuery(1);
    // this.getData();
    this.handleSearch(true);
  },
};

</script>

<style lang="less">
.ivu-select-dropdown {
  z-index: 1000;
}
.ivu-menu {
  z-index: 0;
}
.downBtn {
  height: 60px;
  display: flex;
  align-items: center;
}
.dtpTypeCon {
  display: flex;
  align-items: center;
  .icon{
    margin-left:-20px;
    z-index:100;
    font-size: 14px;
    color: #808695;
    display: none
  }
}
.dtpTypeCon:hover{
  .icon{
    cursor: pointer;
    display: block
  }
}
</style>
